/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для фактических часов работы над задачами (UC-016).
 * SCOPE: HTTP /api/projects/{id}/actual-hours.
 * DEPENDS: M-FE-API
 * LINKS: M-TASK-ACTUAL-HOURS, V-M-FE-API
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getTaskActualHours - список фактических часов проекта
 * upsertTaskActualHours - upsert с plan-match delete
 * deleteTaskActualHours - удалить запись
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-03 - UC-016.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getTaskActualHours */
/* START_CONTRACT: getTaskActualHours
 * PURPOSE: Получить фактические часы проекта.
 * INPUTS: { projectId, signal }
 * OUTPUTS: AxiosResponse
 * SIDE_EFFECTS: HTTP GET
 * LINKS: M-TASK-ACTUAL-HOURS
 * END_CONTRACT: getTaskActualHours
 */
export function getTaskActualHours(projectId, signal) {
  return apiClient.get(`/api/projects/${projectId}/actual-hours`, { signal });
}
/* END_METHOD_getTaskActualHours */

/* START_METHOD_upsertTaskActualHours */
/* START_CONTRACT: upsertTaskActualHours
 * PURPOSE: Upsert фактических часов; сервер удаляет при совпадении с планом.
 * INPUTS: { projectId, payload }
 * OUTPUTS: AxiosResponse
 * SIDE_EFFECTS: HTTP PUT
 * LINKS: M-TASK-ACTUAL-HOURS
 * END_CONTRACT: upsertTaskActualHours
 */
export function upsertTaskActualHours(projectId, payload) {
  return apiClient.put(`/api/projects/${projectId}/actual-hours`, payload);
}
/* END_METHOD_upsertTaskActualHours */

/* START_METHOD_deleteTaskActualHours */
/* START_CONTRACT: deleteTaskActualHours
 * PURPOSE: Удалить запись фактических часов.
 * INPUTS: { projectId, id }
 * OUTPUTS: AxiosResponse
 * SIDE_EFFECTS: HTTP DELETE
 * LINKS: M-TASK-ACTUAL-HOURS
 * END_CONTRACT: deleteTaskActualHours
 */
export function deleteTaskActualHours(projectId, id) {
  return apiClient.delete(`/api/projects/${projectId}/actual-hours/${id}`);
}
/* END_METHOD_deleteTaskActualHours */
